import { usePlayer } from "@/context/PlayerContext";
import { Link } from "react-router-dom";
import { Play, Pause, X, Radio, Volume2, Volume1, VolumeX } from "lucide-react";

export default function MiniPlayer() {
  const { current, playing, togglePlay, stop, volume, setVolume } = usePlayer();
  if (!current) return null;

  const VolIcon = volume === 0 ? VolumeX : volume < 0.5 ? Volume1 : Volume2;

  return (
    <div
      data-testid="mini-player"
      className="fixed left-0 right-0 z-40 bottom-16 lg:bottom-0 mx-auto max-w-3xl px-3"
    >
      <div className="glass bg-card/95 border border-border rounded-2xl shadow-2xl flex items-center gap-2.5 p-2.5 mb-2">
        <img src={current.logo} alt="" className="w-11 h-11 rounded-xl shrink-0 bg-white" />
        <div className="hidden sm:flex items-center gap-1 h-8 text-rdcgold shrink-0" aria-hidden>
          {playing ? (
            [0, 1, 2, 3].map((i) => (
              <span key={i} className="eq-bar" style={{ animationDelay: `${i * 0.15}s` }} />
            ))
          ) : (
            [0, 1, 2, 3].map((i) => <span key={i} className="eq-bar" style={{ height: "20%", animation: "none" }} />)
          )}
        </div>
        <Link to={`/radio/${current.slug}`} className="min-w-0 flex-1">
          <p className="font-heading font-semibold text-sm truncate">{current.name}</p>
          <p className="text-[11px] text-muted-foreground flex items-center gap-1 truncate">
            <Radio size={10} /> {current.province} · En écoute
          </p>
        </Link>
        <div className="flex items-center gap-1.5 shrink-0">
          <button
            onClick={() => setVolume(volume === 0 ? 0.7 : 0)}
            data-testid="mini-player-mute"
            aria-label="Couper le son"
            className="w-7 h-7 rounded-full hover:bg-secondary flex items-center justify-center text-muted-foreground"
          >
            <VolIcon size={16} />
          </button>
          <input
            type="range" min="0" max="1" step="0.05"
            value={volume}
            onChange={(e) => setVolume(parseFloat(e.target.value))}
            data-testid="mini-player-volume"
            aria-label="Volume"
            className="w-14 sm:w-20 accent-rdcblue cursor-pointer"
          />
        </div>
        <button
          onClick={togglePlay}
          data-testid="mini-player-toggle"
          className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center shrink-0 hover:bg-rdcblue transition-colors"
        >
          {playing ? <Pause size={18} fill="white" /> : <Play size={18} fill="white" className="ml-0.5" />}
        </button>
        <button
          onClick={stop}
          data-testid="mini-player-close"
          className="w-8 h-8 rounded-full hover:bg-secondary flex items-center justify-center shrink-0 text-muted-foreground"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
